import { getPatientTranslation } from "@/i18n-for-patient"
import { formatTranslationsKey } from "@/lib/formatTranslation"
import { ChatThread, getAutoTranslationTargetLanguage } from "@/modules/chats/types/chat-thread"
import { Language } from "@/types/__generated__/union-types"

export const getAutoTranslationGreetingNotice = (language: Language = "GERMAN") =>
  getPatientTranslation(language).chat.greetingAiTranslationNotice

const getGreetingMessage = (
  language: Language = "GERMAN",
  isAdminService: boolean,
  agentFirstName: string,
  agentLastName: string,
  shouldAppendAutoTranslationNotice = false,
) => {
  const chatTranslations = getPatientTranslation(language).chat
  const now = new Date()
  const hours = now.getHours()

  let greetingKey: keyof typeof chatTranslations

  if (hours >= 4 && hours < 12) {
    greetingKey = "greetingBasedOnDaytimeMorning"
  } else if (hours >= 12 && hours < 17) {
    greetingKey = "greetingBasedOnDaytimeAfternoon"
  } else {
    greetingKey = "greetingBasedOnDaytimeEvening"
  }

  const greeting = chatTranslations[greetingKey]
  const messageTemplate = isAdminService
    ? chatTranslations.greetingAdministrativeRequest
    : chatTranslations.greetingNonAdministrativeRequest

  const greetingMessage = `${greeting}, ${formatTranslationsKey(messageTemplate, {
    agentFirstName,
    agentLastName,
  })}`

  return shouldAppendAutoTranslationNotice
    ? `${greetingMessage} ${getAutoTranslationGreetingNotice(language)}`
    : greetingMessage
}

const getGreetingMessageForThread = (selectedThread: ChatThread, agentFirstName: string, agentLastName: string) => {
  const autoTranslationTargetLanguage = getAutoTranslationTargetLanguage(selectedThread)
  const isAutoTranslationEnabled = autoTranslationTargetLanguage !== undefined
  const isAdministrativeRequest = selectedThread.appointmentService === "ADMINISTRATIVE_REQUEST"

  return getGreetingMessage(
    autoTranslationTargetLanguage ?? selectedThread.language,
    isAdministrativeRequest,
    agentFirstName,
    agentLastName,
    isAutoTranslationEnabled,
  )
}

export { getGreetingMessage, getGreetingMessageForThread }
